// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 加載列表

  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Language/Load',
      params: { ...params, orderby: 'sortNo asc' },
    });
  },
  SelectData(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Language/SelectData',
      params,
      transformResponse: [(res) => {
        const { data, code } = JSON.parse(res);

        return { code, data: data ? data.sort((a, b) => b.sort - a.sort).reverse() : data };
      }],
    });
  },
  // 抓取單筆
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_Language/Get',
      params,
    });
  },
  // 新增
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Language/Add',
      data,
    });
  },
  // 更新
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Language/Update',
      data,
    });
  },
  // 刪除
  Delete(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_Language/Delete',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data,
    });
  },
};
